import { useMemo } from 'react'

import { Flex, Typography } from '@percent/lemonade'
import { FieldSectionProps } from './FieldSection.types'
import style from './FieldSection.module.scss'

export function FieldSection({ title, children, subSection }: FieldSectionProps) {
  const contentStyling = useMemo(() => {
    if (subSection) {
      return style.subSectionContent
    }

    if (!title) {
      return style.content
    }

    return style.contentWithBorder
  }, [subSection, title])

  return (
    <div className={!subSection ? style.container : undefined}>
      {title && (
        <Typography variant="default" className={style.title}>
          {title}
        </Typography>
      )}
      <Flex direction="column" gap={8} className={contentStyling}>
        {children}
      </Flex>
    </div>
  )
}
